import { useEffect } from "react";
import {
  ALEXANDER_ALI_PERSON_ID,
  BELLHOPT_HOMEPAGE_WEBPAGE_ID,
  BELLHOPT_ORGANIZATION_ID,
  organizationRef,
  personRef,
} from "./siteEntityRefs";

export const siteStructuredData = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "Organization",
      "@id": BELLHOPT_ORGANIZATION_ID,
      name: "Bellhopt",
      url: "https://www.bellhopt.com",
      logo: "https://www.bellhopt.com/logo.png",
      founder: personRef(),
    },
    {
      "@type": "Person",
      "@id": ALEXANDER_ALI_PERSON_ID,
      name: "Alexander Ali",
      url: "https://www.bellhopt.com",
      image:
        "https://bellhopt-public.s3.us-west-1.amazonaws.com/vrvjrvjnvnjrevnjjnefrvjnrb+gnwvrevsrvb-alexander.jpeg",
      sameAs: ["https://www.linkedin.com/in/alexander-ali-206549164/"],
      jobTitle: "Founder",
      description:
        "Founder of Bellhopt, with a focus on product, software, development, partnerships, and company direction.",
      mainEntityOfPage: {
        "@id": BELLHOPT_HOMEPAGE_WEBPAGE_ID,
      },
      worksFor: organizationRef(),
      affiliation: organizationRef(),
      knowsAbout: [
        "Software Engineering",
        "Software Development",
        "Product Development",
        "Product Engineering",
        "Hospitality Technology",
        "Vacation Rental Technology",
        "Short-Term Rental Technology",
        "Concierge Software",
        "Guest Experience",
        "Strategic Partnerships",
        "Hospitality Partnerships",
        "Vacation Rental Partnerships",
      ],
    },
  ],
};

export function useSiteStructuredData(active = true) {
  useEffect(() => {
    if (!active) {
      return undefined;
    }

    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.dataset.siteStructuredData = "true";
    script.text = JSON.stringify(siteStructuredData);
    document.head.appendChild(script);

    return () => {
      if (script.parentNode) {
        script.parentNode.removeChild(script);
      }
    };
  }, [active]);
}

export default function SiteStructuredData() {
  useSiteStructuredData(true);
  return null;
}
